<template>
  <OringAssistantStepCards :cards="cards" />
</template>

<script setup lang="ts">
import {useORingCalculatorStore} from '@/store/oring-calculator'
import useI18nExtended from '~/composables/usei18nExtended'
import OringAssistantStepCards from './OringAssistantStepCards.vue'
import staticPng  from '~/assets/images/static.png'
import dynamicPng from '~/assets/images/dynamic.png'
import grooveShaftPng from '~/assets/images/groove-shaft.png'
import grooveBorePng from '~/assets/images/groove-bore.png'
import {storeToRefs} from 'pinia'

const i18n = useI18nExtended()
const store = useORingCalculatorStore()
const {oringAssistantIsDynamic, oringAssistantGrooveInShaft} = storeToRefs(store)

const cards = [
  {
    title: i18n.tv('Frontend.Title.Movement', 'ORingConfiguratorImport'),
    description: i18n.tv('Frontend.Message.Movement', 'ORingConfiguratorImport'),
    model: oringAssistantIsDynamic,
    options: [
      {value: false, label: i18n.tv('Frontend.Application.Static', 'ORingConfiguratorImport'), imgUrl: staticPng},
      {value: true, label: i18n.tv('Frontend.Application.Dynamic', 'ORingConfiguratorImport'), imgUrl: dynamicPng}
    ],
    popupContent: {title: i18n.tv('Frontend.Title.Movement', 'ORingConfiguratorImport'), content: i18n.tv('Frontend.Info.MovementOne', 'ORingConfiguratorImport')}
  },
  {
    title: i18n.tv('Frontend.Title.GroovePosition', 'ORingConfiguratorImport'),
    description: i18n.tv('Frontend.Message.GroovePosition', 'ORingConfiguratorImport'),
    model: oringAssistantGrooveInShaft,
    options: [
      {value: true, label: i18n.tv('Frontend.Application.GrooveInShaft', 'ORingConfiguratorImport'), imgUrl: grooveShaftPng},
      {value: false, label: i18n.tv('Frontend.Application.GrooveInBore', 'ORingConfiguratorImport'), imgUrl: grooveBorePng}
    ],
    popupContent: {title: i18n.tv('Frontend.Title.GroovePosition', 'ORingConfiguratorImport'), content: i18n.tv('Frontend.Info.GroovePositionOne', 'ORingConfiguratorImport')}
  }
]

</script>
